import React, { history, useEffect, useState, useMemo } from "react";

import $ from "jquery";
import Swal from "sweetalert2";
import services from "../../../services/services";
import { listTaskOrders, SelectAllContactListFromSC } from "../customer/CustomerContactList";
import DatePicker from "react-datepicker";
import { SelectAllContactList } from "../customer/CustomerContactList";
import Pagination from "../../../utility/pagination";
import { requestObject } from "../../../utility/requestObject";
import { getInspectionType } from "../customer/CustomerContactList";
import { loadingComponent } from "../../../utility/Loading";
import moment from 'moment';
import getcustomerLists from "../customer/customer_api";
import Search from "../../../utility/search";
import { LoadingComponentForSubmit } from "../../../utility/loadingforsubmit";
import customerVehicle from "../vehicle/customer_vehicle";
import { Approved, Completed, Inspector } from "../../constant";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { Technician } from "../../constant";

import { SendtocustomerfromTaskOrder, SendtocustomerfromTO, SendtocustomerTO } from "../../../utility/sendtocustomer";
import { sendtocustomerCheck } from "../../../utility/sendtocustomer";
import Checkbox from "../../../utility/Checkbox";
import ListOfContacts from "../customer/CustomerContactList";
import { CustomercontactId } from "../customer/CustomerContactList";
import AddRemoveInputField from "../../../utility/AddRemoveInputField";
import vehicle_details_api from "../vehicle/vehicle_details_api";
export function titleCase(string) {
   return string[0].toUpperCase() + string.substr(1).toLowerCase()
}
const TaskOrder = () => {
   const { customerIdFrom, vehicleIdFrom, customerNameFrom, vehicleVINFrom } = useParams();
   const [checked, setChecked] = useState([]);
   const [CustomerContactList, setCustomerContactList] = useState([]);
   const [emailforsendtoct, setInputEmailList] = useState([{}]);
   const [totalpages1, settotalPages1] = useState();
   const [sortingField, setSortingField] = useState("");
   const [displayPage1, setdisplayPage1] = useState([]);
   const [fkAccountId, setAccountId] = useState(1);
   const [totalItems1, setTotalItems1] = useState(0);
   const [currentPage1, setCurrentPage1] = useState(1);
   const [totalRecors1, setTotalRecord1] = useState([]);
   const [customerList, setCustomerList] = useState([]);
   const [customerId, setCustomerIds] = useState();
   const [sendtocustomerId, sendtoCustomerId] = useState();
   const [vehicleList, setVehicleList] = useState([]);
   const [latestDate, setLatestDate] = useState('');
   const [WorkOrder, setWorkOrder] = useState('');

   const [enableList, setEnable] = useState([]);

   const [roles, setRoles] = useState("");
   const [loading, setLoading] = useState("");
   const [sortingOrder, setSortingOrder] = useState("");
   const [TotalTaskOrder, setTotalTaskOrder] = useState([]);
   const [TaskList, setTotalTaskList] = useState([]);
   const [inspectionNames, setInspecName] = useState([]);
   const [inspectionNamearray, setInspecNamearray] = useState([]);

   const [inspectiondisable, setInspecchecked] = useState([]);

   const [inspectionStatus, setInspecStatus] = useState([]);

   const [InspectionTypesStatus, setInspectionTypesStatus] = useState([]);

   const [originalDate, setOriginalDate] = useState(new Date());
   const [vehicleId, setVehicleId] = useState();
   const [notes, setNotes] = useState();
   const [cid, setCustomerId] = useState([]);
   const [orderId, setOrderId] = useState([]);
   const [inspectionTypes, setInspectionTypes] = useState();
   const listOfInspectionTypes = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];
   const [ITEMS_PER_PAGE, setitemperdocs] = useState(10);
   const [displayPage, setdisplayPageForInspection] = useState([]);
   const [currentPage, setCurrentPage] = useState(1);
   const [search, setSearch] = useState("");

   const [fromDate, setFromDate] = useState();
   const [toDate, setToDate] = useState();
   const [statusList, setStatusList] = useState([]);
   const [taskOrderSelectedID, setTaskOrderId] = useState('');

   const [vechileDetails, setVehicleDetails] = useState([]);

   let navigation = useNavigate();
   const onlyUnique = (value, index, self) => {
      return self.indexOf(value) === index;
   }



   /////////////////////////////vehicle search/////////////////////////
   const searchVehicleList = (vehicleName) => {

      customerVehicle(customerId, "1", ITEMS_PER_PAGE, vehicleName, "", ITEMS_PER_PAGE, setTotalItems1, settotalPages1, setCurrentPage1, setVehicleList, setTotalRecord1, setdisplayPage1, '', '', '', true);

   }
   const inlineEw =
   {
      textAlign: "left",
      width: "10%",
      paddingRight: "10px"
   }

   const inlineTwl =
   {
      width: "12%"
   }

   const inlineFw =
   {
      width: "30%"
   }

   const inlineTf =
   {
      width: "25%"
   }

   const inlineTw =
   {
      width: "20%"
   }

   const inlineFt =
   {
      width: "15%"
   }

   const [customerName, setCustomerName] = useState("");
   const [Vehiclesearch, setvehicleSearch] = useState("");




   const headers =
      [
         { name: "Task Order Name", field: "Task order name", sortable: true, inlineStyle: inlineTf },
         { name: "Customer Name", field: "Customer name", sortable: true, inlineStyle: inlineFt },
         { name: "Unit / VIN Number", field: "Unit number", sortable: true, inlineStyle: inlineEw },
         // { name: "VIN Number", field: "VIN Number", sortable: true, inlineStyle: inlineEw },
         { name: "Assign Date", field: "Assigned date", sortable: true, inlineStyle: inlineEw },
         { name: "Status", inlineStyle: inlineEw },
         { name: "Actions", inlineStyle: inlineEw }
      ];

   const searchCustomerList = (customerName) => {
      if (customerName !== "") {
         setCustomerName(customerName);
         getcustomerLists("1", ITEMS_PER_PAGE, customerName, ITEMS_PER_PAGE, setTotalItems1, settotalPages1, setCurrentPage1, setCustomerList, setTotalRecord1, setdisplayPage1, sortingField, sortingOrder, '', true);
      } else {
         setCustomerName();
      }


   }

   useEffect(() => {
      // $("#emailErrorTaskOrder").hide()
      sessionStorage.removeItem("workOrderNumber");
      sessionStorage.removeItem("verifiedBy");
      setRoles(localStorage.getItem("Userroles"));
      $("#toDateError").hide('');
      $("#vehicleData").hide();
      $("#taskOrderForm").hide();
      $(".error").hide();
      $("#inspectionerror").hide();
      listTaskOrders("1", ITEMS_PER_PAGE, setTotalTaskOrder, setTotalTaskList, setdisplayPageForInspection, "", "", "");
      listAllStatus();


      if (sessionStorage.getItem("naviationfromVehicleDetails") == "taskOrderAddTO") {
         document.getElementById("AddTOPOP").click();
         customerIds('', '', customerNameFrom, customerIdFrom);
         handleChange_vhicle('', '', vehicleVINFrom, vehicleIdFrom, '', '');
         sessionStorage.removeItem("naviationfromVehicleDetails");
      } else {
         document.getElementById("closeModalforadd").click();

      }
   }, []);

   const customerIds = (event, index, name, customerId) => {
      setSearch(name)
      // $("#searchText").val(name);
      setvehicleSearch("");
      sessionStorage.setItem("searchValue", name);
      // alert($("#flexRadioDefault1").val());
      //sessionStorage.setItem("cid",name);
      //  setCustomerIds($("#flexRadioDefault1").val());
      setCustomerIds(customerId);
      searchCustomerList(name);
      // const yesBtn = document.getElementById('flexRadioDefault1');
      // yesBtn.checked = true;
      // if (event.target.value !== "") {

      //    $("#customerNames").hide();

      //    $("#vehicleData").show();
      // } else {

      //    $("#vehicleData").hide();
      // }
      if (sessionStorage.getItem("naviationfromVehicleDetails") == "taskOrderAddTO") {
         $("#customerNames").hide();
         $("#vehicleData").show();
      } else {
         if (event.target.value !== "") {

            $("#customerNames").hide();

            $("#vehicleData").show();
         } else {

            $("#vehicleData").hide();
         }
      }
      //onChange(event.target.value)
   }

   const handleChange_vhicle = (event, index, name, vehicleId, vehicleTypeName, trailerSubTypeName) => {
      // alert(vehicleTypeName+'  '+trailerSubTypeName);

      if (vehicleTypeName == '') {
         // sessionStorage.getItem("vehicleTypeName")
      } else {
         sessionStorage.setItem("vehicleTypeName", vehicleTypeName)
      }

      if (trailerSubTypeName == '') {
         // sessionStorage.getItem("trailerSubTypeName")
      } else {
         sessionStorage.setItem("tankerSubTypeName", trailerSubTypeName)
      }



      // if(customerIdFrom!=''&&vehicleIdFrom!=''){
      //    setVehicleId(vehicleId);
      // }else{
      //    setVehicleId($("#flexVehicleRadioDefault1").val());
      // }

      setVehicleId(vehicleId);

      $("#vehicleList").hide();
      $("#taskOrderForm").show();
      searchVehicleList(name);
      setvehicleSearch(name);
      // const yesBtn = document.getElementById('flexVehicleRadioDefault1');
      // yesBtn.checked = true;
      //onChange(event.target.value)
   }

   const listAllStatus = () => {

      var cto =
      {

         "": ""

      }

      var requestOptions = requestObject.RequestHeader(cto);

      services.listAllStatus(requestOptions).then((res) => {
         setStatusList(res.rows);

      })

   }

   var array = [];
   var arrayinspection = [];
   function sort_by_key(array, key) {
      return array.sort(function (a, b) {
         var x = a[key]; var y = b[key];
         return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      });
   }
   function unique(obj) {
      var uniques = [];
      var stringify = {};
      for (var i = 0; i < obj.length; i++) {
         var keys = Object.keys(obj[i]);
         keys.sort(function (a, b) { return a - b });
         var str = '';
         for (var j = 0; j < keys.length; j++) {
            str += JSON.stringify(keys[j]);
            str += JSON.stringify(obj[i][keys[j]]);
         }
         if (!stringify.hasOwnProperty(str)) {
            uniques.push(obj[i]);
            stringify[str] = true;
         }
      }
      return uniques;
   }
   const removeDupliactes = (values) => {
      let concatArray = values.map(eachValue => {
         return Object.values(eachValue).join('')
      })
      let filterValues = values.filter((value, index) => {
         return concatArray.indexOf(concatArray[index]) === index

      })
      return filterValues
   }
   const updateTask = (workorder,inspectionData, inspectionStatus, customerName, orderdate, inspctionName, vehicleId, customerId, orderId, notes) => {
      // alert(inspectionStatus)
      vehicle_details_api(vehicleId, setVehicleDetails, setCustomerId, setLoading, setCustomerContactList);
      setInspecStatus(inspectionStatus);
      setNotes(notes ? notes : "");
      setInspectionTypes("");
      setInspecName("");

      $("#updateworkorder").val(workorder?workorder:"")
      for (var key in inspctionName) {
         array.push(inspctionName[key])
         setInspecName(array);
      }


      arrayinspection.push(sort_by_key(inspectionData, 'name'));




      // setInspecStatus(inspectionStatus);
      setCustomerName(customerName);
      var request =
      {

      };


      var requestOptions = requestObject.RequestHeader(request);

      var arrayPay = [];
      var inspectionNames = new Array();
      services.getInspectionTypeS(requestOptions).then((res) => {


         setInspectionTypesStatus(res.rows);
         var dummayarray = res.rows;

         var tempArray = [];

         for (var i = 0; i < dummayarray.length; i++) {

            console.log("names==" + dummayarray[i].name)



            tempArray.push({
               "id": dummayarray[i].id, "name": dummayarray[i].name,
               "status": null
            })



         }





         var confirmedList = tempArray.filter((a) => {

            return !inspectionData.find((p) => p.name === a.name);



         });


         setInspecNamearray(confirmedList);



         setInspectionTypesStatus(confirmedList);
         // for(var i=0;i<res.rows.length;i++)
         // {
         //    var booktemp = {
         //       "id" : res.rows[i].id,

         //       "name" :  res.rows[i].name,
         //       "status":
         //    };
         // }

         for (var i = 0; i < sort_by_key(res.rows, 'name').length; i++) {
            for (var j = 0; j < sort_by_key(inspectionData, 'name').length; j++) {

               if (res.rows[i].name === inspectionData[j].name) {
                  var inspection =
                  {
                     "id": res.rows[i].id,

                     "name": res.rows[i].name,
                     "status": inspectionData[j].inspectionStatus
                  }

                  inspectionNames.push(inspection);
               } else {

               }

            }

            // arrayinspection.push(inspectionData[i].inspectionStatus)



         }
         var dummayarray = res.rows;
         var tempArray = [];
         for (var i = 0; i < dummayarray.length; i++) {

            // const rr=dummayarray[i].name;
            for (var j = 0; j < sort_by_key(inspectionData, 'name').length; j++) {

               if (res.rows[i].name === inspectionData[j].name) {

                  tempArray.push({ "id": dummayarray[i].id, "name": dummayarray[i].name, "status": inspectionData[j].inspectionStatus })
               }
               else {

                  //tempArray.push({"id":dummayarray[i].id,"name":dummayarray[i].name, "status":null})

               }

            }


         }

         // tempArray.push(confirmedList);
         var output = confirmedList.concat(tempArray);
         console.log("results==" + JSON.stringify(output))
         const set = new Set(output.map(item => JSON.stringify(item)));
         const dedup = [...set].map(item => JSON.parse(item));
         //  console.log(`Removed ${tempArray.length - dedup.length} elements`);
         // console.log(dedup);

         setInspecchecked(unique(dedup));
         dedup.filter((obj, pos, arr) => {
            return arr.map(mapObj =>
               mapObj.name).indexOf(obj.name) == pos;
         });

         // removeDupliactes(standardsList)


      });


      //getInspectionType(setInspectionTypes);
      setOriginalDate(new Date(orderdate));
      setVehicleId(vehicleId);
      setCustomerId(customerId);
      setOrderId(orderId);
   }
   const addInspection = (workOrderNumber,taskOrderId, inspectionName, vehicleId, customerId) => {

      localStorage.setItem("customerId", customerId);
      localStorage.setItem("vehicleId", vehicleId);
      sessionStorage.setItem("taskOrderfromInspection", inspectionName);
      sessionStorage.setItem("workOrderNumber", workOrderNumber);
      navigation("/addInspection/" + taskOrderId + '/' + customerId + '/' + vehicleId);

   }
   const updateTaskOrder = () => {

      var inspectionTypeIDs = [];
      if ($("#taskorderName").val() === "") {
         document.getElementById('taskorderName').focus();
         $("#taskOrderNameErrorUpdate").show();

         return false;

      } else {
         // $(".error").hide();
         $("#taskOrderNameErrorUpdate").hide();
         if ($("#updateworkorder").val() == '') {
            document.getElementById('updateworkorder').focus();
            $("#workOrderNumberError").show();
            return false
         }else{
            $("#workOrderNumberError").hide();
         
         if ($("#originalDate").val() == '') {
            document.getElementById('originalDate').focus();
            $("#originDateError").show();
            return false
         } else {

            $('input:checkbox[name=contactListemails]:checked').each(function () {

               inspectionTypeIDs.push($(this).val());
            });

            $('input:checkbox[name=contactListemailsDisable]:checked').each(function () {

               inspectionTypeIDs.push($(this).val());

            });
            if (inspectionTypeIDs.length > 0) {
               document.getElementById("closeModal").click();
               $("#inspectionerror").hide();
               $("#loadingforsubmit").show();
               var cto =
               {

                  "name": $("#taskorderName").val(),

                  "assignedDate": originalDate,

                  "id": orderId,

                  "inspectionTypeIds": inspectionTypeIDs,

                  "vehicleId": vehicleId,
                  "workOrderNumber":$("#updateworkorder").val(),
                  "customerId": cid,
                  "notes": $("#noteVal").val() ? $("#noteVal").val().trim() : ""

               }
               var requestOptions = requestObject.RequestHeader(cto);

               services.updateTaskOrders(requestOptions).then((res) => {
                  $("#loadingforsubmit").hide();

                  if (res.success) {
                     Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: "",
                        text: res.message,

                        showConfirmButton: true

                     }).then((result) => {
                        if (result.isConfirmed) {
                           listTaskOrders("1", ITEMS_PER_PAGE, setTotalTaskOrder, setTotalTaskList, setdisplayPageForInspection, "", "", "");
                        }
                     });
                  }
                  else {
                     Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: "",
                        text: res.message,

                        showConfirmButton: true

                     }).then((result) => {
                        if (result.isConfirmed) {

                        }
                     });

                  }


               })

            }
            else {
               document.getElementById('noteVal').focus();
               $("#inspectionerror").show();
            }
         }
      }
      }
   }
   const deleteTaskOrder = (taskId, taskName) => {

      Swal.fire({
         title: 'This action will delete Task Order and corresponding Inspections. Do you want to proceed?',
         text: "Task order name : " + titleCase(taskName),
         icon: 'error',
         showCancelButton: true,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'Yes',
         cancelButtonText: 'No'
      }).then(function (results) {
         // Called if you click Yes.
         if (results.isConfirmed) {

            $("#loadingforsubmit").show();
            var cto =
            {

               "id": taskId,


            }
            var requestOptions = requestObject.RequestHeader(cto);
            $("#loadingforsubmit").show();
            services.deleteTaskOrders(requestOptions).then((res) => {
               $("#loadingforsubmit").hide();

               if (res.success) {
                  Swal.fire({
                     position: 'center',
                     icon: 'success',
                     title: "",
                     text: res.message,

                     showConfirmButton: true

                  }).then((result) => {
                     if (result.isConfirmed) {
                        listTaskOrders("1", ITEMS_PER_PAGE, setTotalTaskOrder, setTotalTaskList, setdisplayPageForInspection, "", "", "");
                     }
                  });
               }
               else {
                  Swal.fire({
                     position: 'center',
                     icon: 'error',
                     title: "",
                     text: res.message,

                     showConfirmButton: true

                  }).then((result) => {
                     if (result.isConfirmed) {

                     }
                  });

               }


            })

         }
      },
         function (no) {
            // Called if you click No.
            if (no == 'cancel') {

            }
         });



   }
   const closeModalPopup = () => {

      document.getElementById("closeModal").click();
   }
   const closeModal = () => {

      document.getElementById("closeModal2").click();
   }

   const onInputChangeForVehicle = value => {
      $("#vehicleList").show();
      setvehicleSearch(value);
      // onSearch(value);
      searchVehicleList(value)
      sessionStorage.setItem("searchValue", value);
   };
   const addTO = (customerId, vehicleId) => {


      if (customerId !== undefined) {
         var inspectionTypeIDs = [];
         if ($("#addtaskorderName").val() === "") {

            $("#taskOrderNameErrorAdd").show();
            document.getElementById('addtaskorderName').focus();
            return false;

         } else {
            $("#taskOrderNameErrorAdd").hide();

            if ($("#workorder").val() == '') {
               $('#error-message-workOrderNumber').show();
               document.getElementById('workorder').focus();
               return false;
            }else{
               $('#error-message-workOrderNumber').hide();
               // $(".error").hide();
            if ($("#originalDateAdd").val() == '') {
               document.getElementById('originalDateAdd').focus();
               $("#assignDateErrorAdd").show();
               return false;
            } else {

               $('input:checkbox[name=contactListemails]:checked').each(function () {

                  inspectionTypeIDs.push($(this).val());

               });
               var inspectunIQ = inspectionTypeIDs.filter((v, i, a) => a.indexOf(v) === i);

               if (inspectionTypeIDs.length > 0) {

                  $("#addinspectionerror").hide();
                  document.getElementById("closeModalforadd").click();

                  var cto =
                  {

                     "name": $("#addtaskorderName").val(),

                     "assignedDate": originalDate,

                     "inspectionOrderId": "",

                     "inspectionTypeIds": inspectunIQ,

                     "vehicleId": vehicleId,

                     "customerId": customerId,
                     "workOrderNumber": $("#workorder").val(),
                     "notes": $("#addnotevalues").val() ? $("#addnotevalues").val() : ""

                  }
                  var requestOptions = requestObject.RequestHeader(cto);
                  $("#loadingforsubmit").show();
                  services.createTaskOrder(requestOptions).then((res) => {
                     $("#loadingforsubmit").hide();

                     if (res.success) {
                        Swal.fire({
                           position: 'center',
                           icon: 'success',
                           title: "",
                           text: res.message,

                           showConfirmButton: true

                        }).then((result) => {
                           if (result.isConfirmed) {

                              navigation("/taskOrder/customerId/vehicleId/customerName/vehicleVIN/");
                              window.location.reload();
                              //listTaskOrders("1", ITEMS_PER_PAGE, setTotalTaskOrder, setTotalTaskList, setdisplayPageForInspection);
                           }
                        });
                     } else {
                        Swal.fire({
                           position: 'center',
                           icon: 'error',
                           title: "",
                           text: res.message,

                           showConfirmButton: true

                        }).then((result) => {
                           if (result.isConfirmed) {

                           }
                        });

                     }


                  })
               } else {

                  $("#addinspectionerror").show();
                  document.getElementById('addnotevalues').focus();
                  return false;
               }

            }
         }

         }
      } else {
         Swal.fire({
            position: 'center',
            icon: 'error',
            title: "",
            text: "Please choose a customer",

            showConfirmButton: true

         }).then((result) => {
            if (result.isConfirmed) {

            }
         });
      }


   }

   const onInputChange = value => {
      $("#customerNames").show();
      $("#vehicleData").hide();
      $("#taskOrderForm").hide();

      setSearch(value);
      // onSearch(value);
      //  if(value==""){
      //   document.getElementById("").reset();
      //  }

      sessionStorage.setItem("searchValue", value);
      searchCustomerList(value);
   };
   const listTaskOrders = (pageNumber, pageSize, setTotalTaskOrder, setTotalTaskList, setdisplayPageForInspection, statusId, fromDate, toDate) => {
      var listoftask =
      {

         "pageNumber": pageNumber,
         "pageSize": pageSize,
         "sortBy": "",
         "sortDir": "",
         "statusId": statusId,
         "fromDate": fromDate ? moment($("#fromDate").val()).format('YYYY-MM-DD') : '',
         "toDate": toDate ? moment($("#toDate").val()).format('YYYY-MM-DD') : '',
         "isActive": true,

      }

      var requestOptions = requestObject.RequestHeader(listoftask);
      services.listTaskOrder(requestOptions).then((res) => {

         $("#loading").hide();
         setTotalTaskOrder(res.customValues ? res.customValues.totalNumberOfRecords : 0);
         var displaypages = [];
         if (res.customValues) {
            for (var i = 1; i <= parseInt(Math.ceil(res.customValues.totalNumberOfRecords / 10)); i++) {
               displaypages.push(i * 10);
            }

         } else {

         }


         setdisplayPageForInspection(displaypages);
         if (setTotalTaskList == "") {

         } else {
            setTotalTaskList(res.rows ? res.rows : 0);
         }

         // var inspectionApprovedCount=0;
         if (res.rows != null) {
            if (res.rows.length > 0) {


               var enableData = [];
               var approvedStatus = 1;
               // console.log('TO lenght@@@ '+res.rows.length)
               for (var j = 0; j < res.rows.length; j++) {
                  // console.log('Status Namesss@@@ '+res.rows[j].statusName)

                  if (res.rows[j].statusName == 'In Process') {
                     if (res.rows[j].inspectionData.length > 0) {

                        for (var i = 0; i < res.rows[j].inspectionData.length; i++) {
                           // if (res.rows[j].inspectionData[i].inspectionStatus!=null) {
                           if (res.rows[j].inspectionData[i].inspectionStatus == "approved") {
                              // inspectionApprovedCount++;
                              // enableData.push(0)
                              approvedStatus = 0;
                           }
                           // else{
                           //    approvedStatus=0;
                           // }
                           // }
                        }

                     }
                     enableData.push(approvedStatus);
                  } else if (res.rows[j].statusName == 'New') {
                     enableData.push(1)
                  } else if (res.rows[j].statusName == 'Completed') {
                     enableData.push(0)
                  }
               }
               setEnable(enableData);

               //  console.log("Dataa taskorder@@   "+JSON.stringify(enableList));

            } else {
               // alert("677")
            }
         }


      });

   }
   const handlePageChange = (offset) => {
      setCurrentPage(offset);
      listTaskOrders(offset, ITEMS_PER_PAGE, setTotalTaskOrder, setTotalTaskList, setdisplayPageForInspection, $('#statusFilter').val(), fromDate, toDate);


   }
   $('#display_pages_in_items').on('change', function () {
      setitemperdocs(this.value);
      listTaskOrders("1", this.value, setTotalTaskOrder, setTotalTaskList, setdisplayPageForInspection, $('#statusFilter').val(), fromDate, toDate);
   });
   const addTaskOrder = (cname, vin) => {
      if (cname !== "" && vin !== "") {
         document.getElementById("searchValue").value = cname;
         searchCustomerList(cname)
         $("#searchValue").val(cname);

      } else {
         // searchCustomerList()
      }


      $("#vehicleData").hide();
      $("#taskOrderForm").hide();
      $(".error").hide();
      $("#inspectionerror").hide();


      getInspectionType(setInspectionTypes);

   }
   const cancel = () => {
      setInspecchecked([]);
   }
   const inspection_details = (workOrderNumber,taskOrderId, inspectionTypeNname, inspectionStatus, fkAccountId, id, vid, cid) => {
      fkAccountId = cid;
      localStorage.setItem("customerId", cid);
      localStorage.setItem("vehicleId", vid);
      sessionStorage.setItem("naviationfrom", "addinspection");
      if (inspectionTypeNname.match("Cargo Tank Thickness Test")) {

         // if (inspectionStatus === "DRAFT") {
         //    navigation("/cargoTankThicknessTestEdit/" + fkAccountId + '/' + id + '/' + vid);
         // } else {
         //    navigation("/cargoTankThicknessTestRead/" + fkAccountId + '/' + id + '/' + vid);
         // }

         if (inspectionStatus == 'approved' || inspectionStatus === 'Reject' || inspectionStatus === 'approve' || inspectionStatus === 'Rejected' || inspectionStatus == 'APPROVED') {
            return (
               navigation("/cargoTankThicknessTestRead/" + fkAccountId + '/' + id + '/' + vid)
            )
         } else if (inspectionStatus == "DRAFT" || inspectionStatus == "draft") {

            return (
               navigation("/cargoTankThicknessTestEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }
         else if (inspectionStatus == null) {

            addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
         }
         else if (roles.match("Technician")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/cargoTankThicknessTestRead/" + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else if (roles.match("Manager") || roles.match("Supervisor") || roles.match("Owner") || roles.match("Inspector")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/cargoTankThicknessTestEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else {
            return (
               navigation("/cargoTankThicknessTestEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }


      } else if (inspectionTypeNname.match("WET Test Certification")) {

         // if (inspectionStatus === "DRAFT") {
         //    navigation("/wetTestCertificationEdit/" + fkAccountId + '/' + id + '/' + vid);
         // } else {
         //    navigation("/wetTestCertificationRead/" + fkAccountId + '/' + id + '/' + vid);
         // }

         if (inspectionStatus == 'approved' || inspectionStatus === 'Reject' || inspectionStatus === 'approve' || inspectionStatus === 'Rejected' || inspectionStatus == 'APPROVED') {
            return (
               navigation("/wetTestCertificationRead/" + fkAccountId + '/' + id + '/' + vid)
            )
         } else if (inspectionStatus == "DRAFT" || inspectionStatus == "draft") {

            return (
               navigation("/wetTestCertificationEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }
         else if (inspectionStatus == null) {

            addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
         }

         else if (roles.match("Technician")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/wetTestCertificationRead/" + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else if (roles.match("Manager") || roles.match("Supervisor") || roles.match("Owner") || roles.match("Inspector")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/wetTestCertificationEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else {
            return (
               navigation("/wetTestCertificationEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }

      } else if (inspectionTypeNname == "Tractor PM/Inspection" || inspectionTypeNname ==  "Tractor Preventive Maintenance/Inspection") {

         // if (inspectionStatus === "DRAFT") {
         //    navigation("/tractorpmTestEdit/" + fkAccountId + '/' + id + '/' + vid);
         // } else {
         //    navigation("/tractorpmTestRead/" + fkAccountId + '/' + id + '/' + vid);
         // }
         //alert('123 - '+inspectionStatus);
         if (inspectionStatus == 'approved' || inspectionStatus === 'Reject' || inspectionStatus === 'approve' || inspectionStatus === 'Rejected' || inspectionStatus == 'APPROVED') {
            return (
               navigation("/tractorpmTestRead/" + fkAccountId + '/' + id + '/' + vid)
            )
         } else if (inspectionStatus == "DRAFT" || inspectionStatus == "draft") {

            return (
               navigation("/tractorpmTestEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }
         else if (roles.match("Technician")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/tractorpmTestRead/" + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else if (roles.match("Manager") || roles.match("Supervisor") || roles.match("Owner") || roles.match("Inspector")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/tractorpmTestEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else {
            return (
               navigation("/tractorpmTestEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }

      } else if (inspectionTypeNname == "Service Check List") {

         // if (inspectionStatus === "DRAFT") {
         //    navigation("/tractorpmTestEdit/" + fkAccountId + '/' + id + '/' + vid);
         // } else {
         //    navigation("/tractorpmTestRead/" + fkAccountId + '/' + id + '/' + vid);
         // }
         //alert('123 - '+inspectionStatus);
         if (inspectionStatus == 'approved' || inspectionStatus === 'Reject' || inspectionStatus === 'approve' || inspectionStatus === 'Rejected' || inspectionStatus == 'APPROVED') {
            return (
               navigation("/serviceCheckListRead/" + fkAccountId + '/' + id + '/' + vid)
            )
         } else if (inspectionStatus == "DRAFT" || inspectionStatus == "draft") {

            return (
               navigation("/serviceCheckListEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }
         else if (roles.match("Technician")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/serviceCheckListRead/" + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else if (roles.match("Manager") || roles.match("Supervisor") || roles.match("Owner") || roles.match("Inspector")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/serviceCheckListEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else {
            return (
               navigation("/serviceCheckListEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }

      } else if (inspectionTypeNname == "Driver Vehicle Inspection") {

         if (inspectionStatus == 'approved' || inspectionStatus === 'Reject' || inspectionStatus === 'approve' || inspectionStatus === 'Rejected' || inspectionStatus == 'APPROVED') {
            return (
               navigation("/driverVehicleTestRead/" + fkAccountId + '/' + id + '/' + vid)
            )
         } else if (inspectionStatus == "DRAFT" || inspectionStatus == "draft") {

            return (
               navigation("/driverVehicleTestEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }
         else if (roles.match("Technician")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/driverVehicleTestRead/" + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else if (roles.match("Manager") || roles.match("Supervisor") || roles.match("Owner") || roles.match("Inspector")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/driverVehicleTestEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else {
            return (
               navigation("/driverVehicleTestEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }

      } else if (inspectionTypeNname == "Leakage Test") {

         // if (inspectionStatus === "DRAFT") {
         //    navigation("/tractorpmTestEdit/" + fkAccountId + '/' + id + '/' + vid);
         // } else {
         //    navigation("/tractorpmTestRead/" + fkAccountId + '/' + id + '/' + vid);
         // }
         
         if (inspectionStatus == 'approved' || inspectionStatus === 'Reject' || inspectionStatus === 'approve' || inspectionStatus === 'Rejected' || inspectionStatus == 'APPROVED') {
            return (
               navigation("/leakageTestRead/" + fkAccountId + '/' + id + '/' + vid)
            )
         } else if (inspectionStatus == "DRAFT" || inspectionStatus == "draft") {

            return (
               navigation("/leakageTestEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }
         else if (roles.match("Technician")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/leakageTestRead/" + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else if (roles.match("Manager") || roles.match("Supervisor") || roles.match("Owner") || roles.match("Inspector")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/leakageTestEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else {
            return (
               navigation("/leakageTestEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }

      } else if (inspectionTypeNname == "Leakage Test (Method 27)") {

         // if (inspectionStatus === "DRAFT") {
         //    navigation("/leakageTestEdit/" + fkAccountId + '/' + id + '/' + vid);
         // } else {
         //    navigation("/leakageTestRead/" + fkAccountId + '/' + id + '/' + vid);
         // }

         if (inspectionStatus == 'approved' || inspectionStatus === 'Reject' || inspectionStatus === 'approve' || inspectionStatus === 'Rejected' || inspectionStatus == 'APPROVED') {
            return (
               navigation("/leakageTestMethod27Read/" + fkAccountId + '/' + id + '/' + vid)
            )
         } else if (inspectionStatus == "DRAFT" || inspectionStatus == "draft") {

            return (
               navigation("/leakageTestMethod27Edit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }
         else if (roles.match("Technician")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/leakageTestMethod27Read/" + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else if (roles.match("Manager") || roles.match("Supervisor") || roles.match("Owner") || roles.match("Inspector")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/leakageTestMethod27Edit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else {
            return (
               navigation("/leakageTestMethod27Edit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }

      }
      else if (inspectionTypeNname.match("DOT Cargo Tank Test") || inspectionTypeNname.match("DOT Cargo Tank") || inspectionTypeNname.match("DOT Cargo") || inspectionTypeNname.match("Ohio EPA")) {
         // if (inspectionStatus === "DRAFT") {
         //    navigation("/dotCargoEdit/" + fkAccountId + '/' + id + '/' + vid);
         // } else {
         //    navigation("/dotCargoRead/" + fkAccountId + '/' + id + '/' + vid);
         // }

         if (inspectionStatus == 'approved' || inspectionStatus === 'Reject' || inspectionStatus === 'approve' || inspectionStatus === 'Rejected' || inspectionStatus == 'APPROVED') {
            return (
               navigation("/dotCargoRead/" + fkAccountId + '/' + id + '/' + vid)
            )
         } else if (inspectionStatus == "DRAFT" || inspectionStatus == "draft") {

            return (
               navigation("/dotCargoEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }

         else if (roles.match("Technician")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/dotCargoRead/" + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else if (roles.match("Manager") || roles.match("Supervisor") || roles.match("Owner") || roles.match("Inspector")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/dotCargoEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else {
            return (
               navigation("/dotCargoEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }


      }
      else if (inspectionTypeNname.match("Internal Visual Inspection") || inspectionTypeNname.match("Internal Visual")) {

         // if (inspectionStatus === "DRAFT") {
         //    navigation("/internalVisualEdit/" + fkAccountId + '/' + id + '/' + vid);
         // } else {
         //    navigation("/internalVisualRead/" + fkAccountId + '/' + id + '/' + vid);
         // }

         if (inspectionStatus == 'approved' || inspectionStatus === 'Reject' || inspectionStatus === 'approve' || inspectionStatus === 'Rejected' || inspectionStatus == 'APPROVED') {
            return (
               navigation("/internalVisualRead/" + fkAccountId + '/' + id + '/' + vid)
            )
         } else if (inspectionStatus == "DRAFT" || inspectionStatus == "draft") {

            return (
               navigation("/internalVisualEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }
         else if (roles.match("Technician")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/internalVisualRead/" + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else if (roles.match("Manager") || roles.match("Supervisor") || roles.match("Owner") || roles.match("Inspector")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/internalVisualEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else {
            return (
               navigation("/internalVisualEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }

      }
      else if (inspectionTypeNname.match("Pressure test - Retest Inspection") || inspectionTypeNname.match("Pressure Vaccum test - Certificate application") || inspectionTypeNname.match("Pressure Test/Retest Inspection")) {

         // if (inspectionStatus === "DRAFT") {
         //    navigation("/pressureTestEdit/" + fkAccountId + '/' + id + '/' + vid);
         // }
         // else {
         //    navigation("/pressureTestRead/" + fkAccountId + '/' + id + '/' + vid);
         // }

         if (inspectionStatus == 'approved' || inspectionStatus === 'Reject' || inspectionStatus === 'approve' || inspectionStatus === 'Rejected' || inspectionStatus == 'APPROVED') {
            return (
               navigation("/pressureTestRead/" + fkAccountId + '/' + id + '/' + vid)
            )
         } else if (inspectionStatus == "DRAFT" || inspectionStatus == "draft") {

            return (
               navigation("/pressureTestEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }
         else if (roles.match("Technician")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/pressureTestRead/" + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else if (roles.match("Manager") || roles.match("Supervisor") || roles.match("Owner") || roles.match("Inspector")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/pressureTestEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else {
            return (
               navigation("/pressureTestEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }

      }
      else if (inspectionTypeNname.match("Carrier Equipment Inspection")) {
         if (inspectionStatus === "DRAFT") {
            navigation("/carrierEquipmentEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid);
         }
         else {
            navigation("/carrierEquipmentRead/" + fkAccountId + '/' + id + '/' + vid);
         }
      }
      else if (inspectionTypeNname.match("Annual Vehicle Inspection")) {
         // if (inspectionStatus === "DRAFT") {
         //    navigation("/annualVehicle1Edit/" + fkAccountId + '/' + id + '/' + vid);
         // }
         // else {
         //    navigation("/annualVehicleRead/" + fkAccountId + '/' + id + '/' + vid);
         // }
         if (inspectionStatus == 'approved' || inspectionStatus === 'Reject' || inspectionStatus === 'approve' || inspectionStatus === 'Rejected' || inspectionStatus == 'APPROVED') {
            return (
               navigation("/annualVehicleRead/" + fkAccountId + '/' + id + '/' + vid)
            )
         } else if (inspectionStatus == "DRAFT" || inspectionStatus == "draft") {

            return (
               navigation("/annualVehicle1Edit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }
         else if (roles.match("Technician")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/annualVehicleRead/" + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else if (roles.match("Manager") || roles.match("Supervisor") || roles.match("Owner") || roles.match("Inspector")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/annualVehicle1Edit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else {
            return (
               navigation("/annualVehicle1Edit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }

      }
      else if (inspectionTypeNname.match("External Visual Inspection") || inspectionTypeNname.match("External/Visual Inspection")) {
         // if (inspectionStatus === "DRAFT") {
         //    navigation("/editExternalVisual/" + fkAccountId + '/' + id + '/' + vid);
         // }
         // else {
         //    navigation("/externalVisualRead/" + fkAccountId + '/' + id + '/' + vid);
         // }

         if (inspectionStatus == 'approved' || inspectionStatus === 'Reject' || inspectionStatus === 'approve' || inspectionStatus === 'Rejected' || inspectionStatus == 'APPROVED') {
            return (
               navigation("/externalVisualRead/" + fkAccountId + '/' + id + '/' + vid)
            )
         } else if (inspectionStatus == "DRAFT" || inspectionStatus == "draft") {

            return (
               navigation("/editExternalVisual/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }
         else if (roles.match("Technician")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/externalVisualRead/" + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else if (roles.match("Manager") || roles.match("Supervisor") || roles.match("Owner") || roles.match("Inspector")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/editExternalVisual/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else {
            return (
               navigation("/editExternalVisual/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }

      } else if (inspectionTypeNname.match("Gassoline Delivery Tank - Pressure Vaccum Test")) {
         if (inspectionStatus === "DRAFT") {
            navigation("/gasolineDeliveryTankPressureVacuumTestEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid);
         } else {
            navigation("/gasolineDeliveryTankPressureVacuumTestRead/" + fkAccountId + '/' + id + '/' + vid);
         }
         //  navigation("/gasolineDeliveryTankPressureVacuumTestRead/" + fkAccountId + '/' + id + '/' + vid);
      } else if (inspectionTypeNname.match("Vapor Tightness Certification")) {

         // if (inspectionStatus === "DRAFT") {
         //    navigation("/inspectionVaporTightnessCertificateEdit/" + fkAccountId + '/' + id + '/' + vid);
         // } else {
         //    navigation("/inspectionVaporTightnessCertificateRead/" + fkAccountId + '/' + id + '/' + vid);
         // }
         if (inspectionStatus == 'approved' || inspectionStatus === 'Reject' || inspectionStatus === 'approve' || inspectionStatus === 'Rejected' || inspectionStatus == 'APPROVED') {
            return (
               navigation("/inspectionVaporTightnessCertificateRead/" + fkAccountId + '/' + id + '/' + vid)
            )
         } else if (inspectionStatus == "DRAFT" || inspectionStatus == "draft") {

            return (
               navigation("/inspectionVaporTightnessCertificateEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }
         else if (roles.match("Technician")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/inspectionVaporTightnessCertificateRead/" + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else if (roles.match("Manager") || roles.match("Supervisor") || roles.match("Owner") || roles.match("Inspector")) {
            if (inspectionStatus === 'APPROVED PENDING' || inspectionStatus === 'approve pending' || inspectionStatus == 'APPROVE PENDING') {
               return (
                  navigation("/inspectionVaporTightnessCertificateEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
               )
            }
            else if (inspectionStatus == null) {

               addInspection(workOrderNumber,taskOrderId, inspectionTypeNname, vid, cid);
            }
         } else {
            return (
               navigation("/inspectionVaporTightnessCertificateEdit/" + taskOrderId + '/' + fkAccountId + '/' + id + '/' + vid)
            )
         }
      }


   }

   const openModal = (Customer_Id, taskOrderId) => {
      sendtoCustomerId(Customer_Id);
      setTaskOrderId(taskOrderId);
      // alert(taskOrderId)
      $('input:checkbox[name=contactListemails]').prop('checked', false).attr('checked', 'checked');
      $('input:checkbox[name=contactSelectAll]').prop('checked', false).attr('checked', 'checked');

      ListOfContacts(Customer_Id, setCustomerContactList);
   }

   const searchData = () => {
      const startDate = $("#fromDate").val();
      const endDate = $("#toDate").val();
      if (startDate != '' && endDate != '') {

         if (endDate < startDate) {
            $("#toDateError").show('');
            return false;
         } else {
            $("#toDateError").hide('');
            listTaskOrders("1", ITEMS_PER_PAGE, setTotalTaskOrder, setTotalTaskList, setdisplayPageForInspection, $('#statusFilter').val(), fromDate, toDate);
            return true
         }
      }
      listTaskOrders("1", ITEMS_PER_PAGE, setTotalTaskOrder, setTotalTaskList, setdisplayPageForInspection, $('#statusFilter').val(), fromDate, toDate);
   }

   const resetAllValues = () => {
      $("#toDateError").hide('');
      // $('#reset_value').find('input:text').val('');
      $('#statusFilter').val('');
      // $('#fromDate').val('');
      // $('#toDate').val('');
      setFromDate('');
      setToDate('');
      listTaskOrders("1", ITEMS_PER_PAGE, setTotalTaskOrder, setTotalTaskList, setdisplayPageForInspection, "", "", "", "");
   }


   return (
      <>
         {loadingComponent}
         {LoadingComponentForSubmit}
         <div class="main-panel">
            <div class="content-wrapper" style={{ display: "block;" }}>
               <div class="row">
                  <div class="col-lg-11 col-md-12 m-auto mb-2 ">
                     <h4 class="font-weight-bold my-4 text-uppercase">Task orders</h4>
                  </div>
               </div>

               <div class="row">
                  <div class="col-lg-11 col-md-12 m-auto grid-margin stretch-card">
                     <div class="card">
                        <div class=" cd-desktop-to-fliter">
                           {/* <div class="d-flex align-items-center">
                      <div className="mr-2 d-flex align-items-center">
                        <label className="m-0"> Status: </label>
                           <select class="form-select form-control ml-1" aria-label="Default select example">
                              <option selected>select menu</option>
                              <option value="2">New</option>
                              <option value="1">InProces</option>
                              <option value="2">Completed</option>
                           </select>
                       </div>
                      <div className="mr-2 d-flex align-items-center"> <label className="ml-2 m-0">From</label><input className="text-uppercase ml-2 date-sm-tx" type="date" id="date" placeholder="From"/><label class="ml-2 m-0">TO</label><input className="text-uppercase ml-2 date-sm-tx" type="date" id="date" placeholder="From"/></div>
                      <div className="to-filter-btns"> <a href="#" className="btn btn-primary mr-1 px-3 d-flex align-items-center" >Search</a> <a href="#" className="btn btn-outline-dark mr-1 px-3 d-flex align-items-center" >Reset</a></div>
                  </div> */}
                           <div class="d-flex align-items-center" id="reset_value">
                              <div className="mr-2 d-flex align-items-center">
                                 <label className="m-0"> Status </label>
                                 <select class="form-select form-control ml-1" aria-label="Default select example" id="statusFilter" style={{ maxHeight: "38px", marginLeft: "4px" }}>
                                    <option selected value=''>Select</option>
                                    {
                                       statusList ? statusList.map((data, index) => (
                                          data.name != 'TO Created' && data.name != 'To Be Approved' && data.name != 'Cancelled' && data.name != 'Cancelled and Removed' ?
                                             <option value={data.id} >{data.name}</option> : ''
                                       )) : <option value=""></option>
                                    }
                                 </select>
                              </div>
                              <div className="mr-2 d-flex align-items-center">
                                 <label className="ml-2 m-0">From</label>
                                 {/* <input className="text-uppercase ml-2 date-sm-tx" type="date" id="date" placeholder="From"/> */}
                                 <DatePicker id="fromDate" selected={fromDate} onChange={(date) => setFromDate(date)} name="fromDate" class="form-control" placeholderText="MM/DD/YYYY" />
                                 <label class="ml-2 m-0">TO</label>
                                 {/* <input className="text-uppercase ml-2 date-sm-tx" type="date" id="toDate" placeholder="From"/> */}
                                 <DatePicker id="toDate" minDate={moment(fromDate).toDate()} selected={toDate} onChange={(date) => setToDate(date)} name="toDate" class="form-control" placeholderText="MM/DD/YYYY" />
                              </div>

                              <div className="to-filter-btns"> <a className="btn btn-primary mr-1 px-3 d-flex align-items-center" onClick={searchData}>Search</a> <a className="btn btn-outline-dark mr-1 px-3 d-flex align-items-center" onClick={resetAllValues}>Reset</a><span id="toDateError" class="error">To date should be greater than From date</span></div>
                           </div>

                           {roles.match(Technician) || roles.match(Inspector) ? "" : <div class="ml-auto">
                              <a class="btn btn-success" data-bs-toggle="modal" data-bs-target="#myModal" onClick={() => addTaskOrder("", "")} id="AddTOPOP">Add TO</a>
                           </div>}

                           {/* <div class="d-flex align-self-start mb-1 mt-1">

                  {roles.match("Technician")||roles.match("Inspector")?"":<a  class="btn btn-success" data-bs-toggle="modal" data-bs-target="#adddocs">Add Task</a>}
                  </div> */}
                        </div>

                        <div class="cd-mobile-to-fliter">
                           {roles.match(Technician) || roles.match(Inspector) ? "" : <div class="ml-auto">
                              <a class="btn btn-success" data-bs-toggle="modal" data-bs-target="#myModal" onClick={() => addTaskOrder("", "")}>Add TO</a>
                           </div>}
                           <div class="d-flex align-items-center">
                              <div className="mr-2 d-flex align-items-center statusto">

                                 <select class="form-select form-control ml-1" aria-label="Default select example">
                                    <option selected>select menu</option>
                                    <option value="2">New</option>
                                    <option value="1">InProces</option>
                                    <option value="2">Completed</option>
                                 </select>
                              </div>
                              <div className="to-dt-range mr-2">
                                 <span className="mr-2"> <input className="text-uppercase  date-sm-tx" type="date" id="date" placeholder="From" /></span>
                                 <span> <input className="text-uppercase  date-sm-tx" type="date" id="date" placeholder="From" /></span>
                              </div>
                              <div className="to-filter-btns"> <a href="#" className="btn btn-primary mr-1 px-3 d-flex align-items-center" >Search</a> <a href="#" className="btn btn-outline-dark mr-1 px-3 d-flex align-items-center" >Reset</a></div>

                           </div>



                           {/* <div class="d-flex align-self-start mb-1 mt-1">

                  {roles.match("Technician")||roles.match("Inspector")?"":<a  class="btn btn-success" data-bs-toggle="modal" data-bs-target="#adddocs">Add Task</a>}
                  </div> */}
                        </div>







                        <div class="card-body pt-0 pb-0">

                           <div class="row">
                              <div class="col-12">
                                 <div class="table-responsive  border-bottom">

                                    <table class="table table-hover">
                                       <tr>
                                          {headers.map(({ name, field, sortable, thStyle, inlineStyle }) => (
                                             <th
                                                key={name}
                                                onClick={() =>
                                                   sortable ? "" : null
                                                }
                                                class={thStyle} style={inlineStyle}>
                                                {name}

                                                {sortingField && sortingField === field && (

                                                   sortingOrder === "asc"
                                                      ? "↓"
                                                      : "↑"
                                                )}

                                             </th>
                                          ))}
                                       </tr>

                                       <tbody>
                                          {

                                             TaskList.length > 0 ? TaskList.map((data, index) => (



                                                <tr style={{ position: "relative" }} className="my-2">
                                                   <td style={{ width: "25%", maxWidth: "100px", paddingBottom: "75px" }}>

                                                      <span className="text-capitalize" style={{ position: "relative", top: "11px" }}>{data.name ? data.name : "--"}</span>

                                                      <span className="text-capitalize" style={{ position: "absolute", left:"0px", top: "50px", background:"#e3e3e3", color:"#", fontSize:"1.0em", letterSpacing:"0.5px", padding:"10px", borderRadius:"5px", backgroundColor:"#e3e3e3" }}>Work Order Number : {data.workOrderNumber ? data.workOrderNumber : "--"}</span>
                                                      {/* <span className="text-capitalize" style={{ position: "absolute", left:"0px", top: "50px", background:"#666", color:"#fff", fontSize:"1.0em", letterSpacing:"0.5px", padding:"5px 10px"  }}>Work Order Number : {data.workOrderNumber ? data.workOrderNumber : "--"}</span> */}
                                                      <div class="mb-4 to-tb-ins" style={{marginTop:"70px"}}>
                                                         <lable className="to-label">Inspections to perform :

                                                         </lable>
                                                         <>
                                                         </>
                                                         {

                                                            data.inspectionData != null ? data.inspectionData.sort((a, b) => a.name.localeCompare(b.name)).map((data1, index) => {
                                                               return <ul class="px-0 task-list-ord to-grid ">
                                                                  <li>
                                                                     {/* <i class="arrow right mx-2"></i> */}
                                                                     {/* <a href={"/addInspection/" + data.customerId + "/" + data.vehicleId} onClick={() => addInspection(data.inspectionTypeData[s.toString()])}>{data.inspectionTypeData[s.toString()]}</a>  */}



                                                                     {(() => {
                                                                        localStorage.setItem("customerId", data.customerId);
                                                                        localStorage.setItem("vehicleId", data.vehicleId);
                                                                        return <a onClick={() => inspection_details(data.workOrderNumber,data.id, data1.name, data1.inspectionStatus, "1", data1.id, data.vehicleId, data.customerId)} href="" >{data1.name}
                                                                           {/* {(() => {

                                                                           if (data1.inspectionStatus == 'approved' || data1.inspectionStatus === 'Reject' || data1.inspectionStatus === 'approve' || data1.inspectionStatus === 'Rejected' || data1.inspectionStatus == 'APPROVED') {

                                                                           }else if(data1.inspectionStatus=="DRAFT"){


                                                                           }
                                                                        else if(roles.match("Technician")){
                                                                           if (data1.inspectionStatus === 'APPROVED PENDING' || data1.inspectionStatus === 'approve pending' || data1.inspectionStatus == 'APPROVE PENDING') {

                                                                           }
                                                                        }else if(roles.match("Manager")|| roles.match("Owner") || roles.match("Inspector")){
                                                                           if ( data1.inspectionStatus === 'APPROVED PENDING' || data1.inspectionStatus=== 'approve pending' || data1.inspectionStatus == 'APPROVE PENDING' ) {

                                                                           }
                                                                        } else {

                                                                        }
                                                                     })()} */}

                                                                        </a>



                                                                     })()}

                                                                     {(() => {
                                                                        if (data1.inspectionStatus == 'approve pending' || data1.inspectionStatus == "Approved pending" || data1.inspectionStatus == "APPROVED PENDING") {
                                                                           return (
                                                                              <span class=" approve-pending ">To Be Approved</span>
                                                                              // <span class="status-txt approve-pending">{inspection.status ? inspection.status : "--"}</span>
                                                                           )
                                                                        } else if (data1.inspectionStatus == 'Rejected' || data1.inspectionStatus == 'REJECTED') {
                                                                           return (
                                                                              <span class=" reject ">Rejected</span>
                                                                           )
                                                                        } else if (data1.inspectionStatus == 'draft' || data1.inspectionStatus == 'DRAFT') {
                                                                           return (
                                                                              <span class=" draft ">Draft</span>
                                                                           )
                                                                        } else if (data1.inspectionStatus == 'approved' || data1.inspectionStatus == 'approve' || data1.inspectionStatus == 'APPROVED') {
                                                                           return (
                                                                              <><span class=" approved ">Approved</span>
                                                                                 <span class="approved sent-mail">

                                                                                    {(() => {

                                                                                       for (var i = 0; i < data.inspectionData.length; i++) {

                                                                                          if (data.statusName === "completed" || data.statusName === "Completed" && data.inspectionData[i].latestSharedOn !== null) {
                                                                                             return (
                                                                                                <span className="approved smapr" style={{ marginLeft: "0px" }}> <b className="mr-2">Email sent date: <span className="approved">{data.inspectionData[i] != null ? moment(data.inspectionData[i].latestSharedOn).format('MM-DD-YYYY') : ""}</span></b></span>

                                                                                             )
                                                                                          }
                                                                                       }

                                                                                    })()}

                                                                                    {/* {(() => {
                                                                                       if (data.statusName === "completed" || data.statusName === "Completed" && data.latestSharedOn !== null) {
                                                                                          return (
                                                                                             <b className="mr-2">Email sent date:</b>
                                                                                          )
                                                                                       }
                                                                                    })()} */}
                                                                                    {/* {data.statusName === "completed" || data.statusName === "Completed" ? data.latestSharedOn === null ? '' : moment(data.latestSharedOn).format('MM-DD-YYYY') : ''} */}
                                                                                 </span>

                                                                              </>
                                                                           )
                                                                        } else {
                                                                           return (
                                                                              <><span class="status-txt">{data1.inspectionStatus ? data1.inspectionStatus : ""}</span></>
                                                                           )
                                                                        }
                                                                     })()}

                                                                     {/* <small style={{marginLeft:"10px",color:"red"}} className="text-uppercase">{data1.inspectionStatus}</small> */}
                                                                  </li>
                                                               </ul>
                                                            }) : ""}

                                                         <span class="my-1 ml-2 note not-pos-abs"> <b className="red-txt mr-2">Note:</b>  {data.notes ? data.notes : ""}</span>
                                                      </div>
                                                   </td>
                                                   <td class="to-td text-capitalize" style={{ paddingRight: "10px", width: "15%", whiteSpace: "break-spaces", lineHeight: "18px" }}><span>{data.customerName ? data.customerName : "--"}</span></td>
                                                   <td class="to-td text-capitalize pr-3" style={{ width: "15%" }}>    <span>{data.unitNumber ? data.unitNumber : "--"} / <br /> {data.vinnumber ? data.vinnumber : "--"}</span></td>
                                                   {/* <td class="to-td" style={{ paddingRight: "10px" }}>   <span>{data.vinnumber ? data.vinnumber : "--"}</span></td> */}
                                                   <td class="to-td" style={{ width: "15%" }}>  <span>{data.assignedDate ? moment(data.assignedDate).format('MM-DD-YYYY') : "--"}</span></td>
                                                   <td class="to-td" style={{ width: "10%" }}> <span className="break-ws">{data.statusName ? data.statusName : "--"}</span>
                                                      {/* <div className="mt-4">

                                          <ul className="px-1 task-list-ord mt-4">
                                            <li> <b className="green-txt">Approved</b></li>
                                            <li><b className="red-txt">Reject</b></li>
                                          </ul>
                                        </div> */}
                                                   </td>
                                                   {/* {roles.match(Technician)||roles.match(Inspector)?"": data.statusName==="completed"||data.statusName==="Completed" ?"":<td class="to-td" style={{maxWidth:"40px"}}> <span class="ml-auto"> <a class="btn btn-outline-primary text-uppercase" data-toggle="modal" data-target="#updateModal" onClick={() => updateTask(data.name, data.assignedDate, data.inspectionTypeData, data.vehicleId, data.customerId, data.id,data.notes)}>Edit</a></span></td>} */}
                                                   {/* {roles.match(Technician) || roles.match(Inspector) ? "" : data.statusName === "completed" || data.statusName === "Completed" ? <td class="to-td"><button class="btn btn-outline-success text-uppercase to-send-email-btn" data-toggle="modal" data-target="#myModalCustomer" onClick={() => openModal(data.customerId, data.id)}>Send <span style={{ textTransform: "lowercase !important" }}>to</span> Customer</button></td> : <td class="to-td" style={{ maxWidth: "40px" }}> <span class="ml-auto"> <a class="btn btn-outline-primary text-uppercase" data-toggle="modal" data-target="#updateModal" onClick={() => updateTask(data.inspectionData, data.statusName, data.name, data.assignedDate, data.inspectionTypeData, data.vehicleId, data.customerId, data.id, data.notes)}>Edit</a>{data.statusName === "New"?<a class="btn btn-outline-primary text-uppercase" style={{marginLeft:3}} onClick={() => deleteTaskOrder(data.id,data.name)}>Delete</a>:""}</span></td>} */}
                                                   {roles.match(Technician) || roles.match(Inspector) ? "" : data.statusName === "completed" || data.statusName === "Completed" ? <td class="to-td"><button class="btn btn-outline-success text-uppercase to-send-email-btn" data-toggle="modal" data-target="#myModalCustomer" onClick={() => openModal(data.customerId, data.id)}>Send <span style={{ textTransform: "lowercase !important" }}>to</span> Customer</button></td> : <td class="to-td" style={{ minWidth: "90px" }}> <span class="ml-auto"> <a class="btn btn-outline-primary text-uppercase" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#updateModal" onClick={() => updateTask(data.workOrderNumber,data.inspectionData, data.statusName, data.name, data.assignedDate, data.inspectionTypeData, data.vehicleId, data.customerId, data.id, data.notes)}>Edit</a>

                                                      {(() => {
                                                         if (enableList[index] == '0') {
                                                            return ("")
                                                         } else {
                                                            return (
                                                               <a class="btn btn-outline-primary text-uppercase" style={{ marginLeft: 3 }} onClick={() => deleteTaskOrder(data.id, data.name)}>Delete</a>
                                                            )
                                                         }
                                                      })()}

                                                   </span></td>
                                                   }

                                                </tr>
                                             )) : ""

                                          }




                                       </tbody>
                                    </table>
                                 </div>
                              </div>
                              {TaskList.length > 0 ? "" : <div class="no-data"><div class="m-auto"><img src="/images/no-data.png" alt="" /></div><span class="mt-2">No Data Available to Display</span>
                              </div>}
                           </div>
                        </div>
                        {TaskList.length > 0 ?
                           <div class="d-flex align-items-center justify-content-between p-3">
                              <div class="d-flex">
                                 <div class="dropdown show mr-3 ">
                                    <select class="form-control custome-select" class="btn gray-mid-color dropdown-toggle" href="#" role="button" id="display_pages_in_items" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                       {
                                          displayPage.map((data, index) => (
                                             <option value={data}>{data}</option>
                                          ))
                                       }
                                    </select>
                                 </div>
                                 <span class="d-flex align-items-center pagenation-mob">{currentPage * ITEMS_PER_PAGE <= TotalTaskOrder ? currentPage * ITEMS_PER_PAGE : TotalTaskOrder} out of {TotalTaskOrder} Records Displayed</span>
                              </div>
                              <nav aria-label="Page navigation example">
                                 <Pagination
                                    total={TotalTaskOrder}
                                    itemsPerPage={ITEMS_PER_PAGE}
                                    currentPage={currentPage}
                                    onPageChange={handlePageChange}
                                 />

                              </nav>
                           </div> : ""}

                     </div>

                  </div>

               </div>
            </div>

         </div>
         <div id="updateModal" class="modal fade" role="dialog">
            <div class="modal-dialog">


               <div class="modal-content" style={{ maxHeight: "550px" }}>
                  <div class="modal-header">
                     <h5 class="modal-title">Update Task Order</h5>
                     <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => (closeModalPopup())}><span aria-hidden="true">×</span></button>
                  </div>

                  <div class="modal-body scroll-auto">
                     <div className="row">
                        <div class="col-md-12">
                           <div class="form-group mb-3">
                              <label for="wqes" class="w-100">Task Order Name <span class="star">*</span></label>
                              <input type="text" class="form-control" id="taskorderName" placeholder="Task order name" defaultValue={customerName} />
                              <span class="error" id="taskOrderNameErrorUpdate" style={{ marginTop: "20px important" }}>Task order name is required</span>
                           </div>
                           <div class="form-group mb-3">

                                   <img src="images/icons/workorder-icon.svg" alt=""/>
                                   {/* <span class="mr-2 ml-2">Work order Number : </span> */}
                                   <label for="wqes" class="w-100">Work order Number <span class="star">*</span></label>
                                   <input type="input" class="form-control" placeholder="Enter W/O" id="updateworkorder" />
                                   <span class="error" id="workOrderNumberError">Work order number is required</span><br />
                          </div>
                           <div class="form-group mb-3">
                              <label for="wqes" class="w-100">Assign Date <span class="star">*</span></label>
                              {/* <input type="text" class="form-control" id="qwes"  defaultValue={orderDate}/> */}
                              <DatePicker id="assignDate" minDate={moment(originalDate).toDate()} selected={originalDate} onChange={(date) => setOriginalDate(date)} name="originalDate" class="form-control" id="originalDate" placeholderText="MM/DD/YYYY" />
                              <span class="error" id="originDateError">Assign date is required</span><br />
                           </div>
                           <div class="form-group">
                              <label for="wqes" class="w-100">Inspection List <span class="star">*</span></label>
                              <div class="col-md-12" style={{ marginTop: "16px" }}><input type="checkbox" class="form-check-input" name="contactSelectAll" onClick={(e) => SelectAllContactList(e, "")} />
                                 <label style={{ marginLeft: "26px", fontWeight: "bold", marginBottom: "0px" }}   >Select All</label></div>

                              {

                                 inspectiondisable ? inspectiondisable.sort((a, b) => a.name.localeCompare(b.name)).map((inspection, index) => {

                                    return (<>

                                       {/* {
                                          inspectionNames.includes(inspection.name) ?
                                             <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" class="form-check-input" defaultValue={inspection.id} name={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? "contactListemailsDisable" : "contactListemails"} defaultChecked={true} disabled={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? true : false} /><label class="form-check-label" for="check1">{inspection.name}</label></div> </div> :
                                             <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" defaultValue={inspection.id} class="form-check-input" name="contactListemails" /><label class="form-check-label" for="check1">{inspection.name}</label></div></div>
                                       } */}

                                       {/* {(() => {

                                          if (inspection.name === "WET Test Certification") {
                                             if (sessionStorage.getItem("vehicleTypeName") === "Trailer" && sessionStorage.getItem("tankerSubTypeName") === "Tanker") {

                                                return (

                                                   <div class="form-check rem-shadow"> <div class="col-md-12">
                                                      {(inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft") ? <input type="checkbox" class="form-check-input" defaultValue={inspection.id} name={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? "contactListemailsDisable" : "contactListemails"} defaultChecked={true} disabled={true} /> : <input type="checkbox" class="form-check-input" defaultValue={inspection.id} name={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? "contactListemailsDisable" : "contactListemails"} />}

                                                      <label class="form-check-label" for="check1">{inspection.name}</label></div> </div>
                                                )
                                             } else {

                                             }

                                          }
                                          else {
                                             return (
                                                <div class="form-check rem-shadow"> <div class="col-md-12">
                                                   {(inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft") ? <input type="checkbox" class="form-check-input" defaultValue={inspection.id} name={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? "contactListemailsDisable" : "contactListemails"} defaultChecked={true} disabled={true} /> : <input type="checkbox" class="form-check-input" defaultValue={inspection.id} name={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? "contactListemailsDisable" : "contactListemails"} />}
                                                   <label class="form-check-label" for="check1">{inspection.name}</label></div> </div>

                                             )
                                          }


                                       })()} */}

{(() => {

if (inspection.name === "WET Test Certification") {
   if (sessionStorage.getItem("vehicleTypeName") === "Trailer" && sessionStorage.getItem("tankerSubTypeName") === "Tanker") {
      if(((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft"))){

      return (
         inspectionNames.includes(inspection.name) ?
<div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" class="form-check-input" defaultValue={inspection.id} name={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? "contactListemailsDisable" : "contactListemails"} defaultChecked={true} disabled={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? true : false} /><label class="form-check-label" for="check1" style={{textTransform:"none"}}>{inspection.name}</label></div> </div> :
<div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" defaultValue={inspection.id} class="form-check-input" name="contactListemails" /><label class="form-check-label" for="check1">{inspection.name}</label></div></div>

      )
      }else{
         return ( inspectionNames.includes(inspection.name) ?
         <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" class="form-check-input" defaultValue={inspection.id} name={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? "contactListemailsDisable" : "contactListemails"} defaultChecked={true} disabled={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? true : false} /><label class="form-check-label" for="check1" style={{textTransform:"none"}}>{inspection.name}</label></div> </div> :
         <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" defaultValue={inspection.id} class="form-check-input" name="contactListemails" /><label class="form-check-label" for="check1" style={{textTransform:"none"}}>{inspection.name}</label></div></div> )
      }
   }else{
      //  <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" class="form-check-input" defaultValue={inspection.id} name={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? "contactListemailsDisable" : "contactListemails"} defaultChecked={true} disabled={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? true : false} /><label class="form-check-label" for="check1">{inspection.name}</label></div> </div>
         // <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" defaultValue={inspection.id} class="form-check-input" name="contactListemails" /><label class="form-check-label" for="check1">{inspection.name}</label></div></div>
      }
   // } else {

   // }

}

else if (inspection.name === "Tractor PM/Inspection" || inspection.name ==  "Tractor Preventive Maintenance/Inspection") {
   if (sessionStorage.getItem("vehicleTypeName") === "Tractor") {
      if(((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft"))){

      return (
         inspectionNames.includes(inspection.name) ?
<div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" class="form-check-input" defaultValue={inspection.id} name={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? "contactListemailsDisable" : "contactListemails"} defaultChecked={true} disabled={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? true : false} /><label class="form-check-label" for="check1" style={{textTransform:"none"}}>{inspection.name}</label></div> </div> :
<div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" defaultValue={inspection.id} class="form-check-input" name="contactListemails" /><label class="form-check-label" for="check1">{inspection.name}</label></div></div>

      )
      }else{
         return ( inspectionNames.includes(inspection.name) ?
         <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" class="form-check-input" defaultValue={inspection.id} name={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? "contactListemailsDisable" : "contactListemails"} defaultChecked={true} disabled={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? true : false} /><label class="form-check-label" for="check1" style={{textTransform:"none"}}>{inspection.name}</label></div> </div> :
         <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" defaultValue={inspection.id} class="form-check-input" name="contactListemails" /><label class="form-check-label" for="check1" style={{textTransform:"none"}}>{inspection.name}</label></div></div> )
      }
   }else{
      //  <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" class="form-check-input" defaultValue={inspection.id} name={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? "contactListemailsDisable" : "contactListemails"} defaultChecked={true} disabled={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? true : false} /><label class="form-check-label" for="check1">{inspection.name}</label></div> </div>
         // <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" defaultValue={inspection.id} class="form-check-input" name="contactListemails" /><label class="form-check-label" for="check1">{inspection.name}</label></div></div>
      }
   // } else {

   // }

}
else if (inspection.name === "Driver Vehicle Inspection") {
   if (sessionStorage.getItem("vehicleTypeName") === "Tractor") {
      if(((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft"))){

      return (
         inspectionNames.includes(inspection.name) ?
<div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" class="form-check-input" defaultValue={inspection.id} name={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? "contactListemailsDisable" : "contactListemails"} defaultChecked={true} disabled={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? true : false} /><label class="form-check-label" for="check1" style={{textTransform:"none"}}>{inspection.name}</label></div> </div> :
<div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" defaultValue={inspection.id} class="form-check-input" name="contactListemails" /><label class="form-check-label" for="check1">{inspection.name}</label></div></div>

      )
      }else{
         return ( inspectionNames.includes(inspection.name) ?
         <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" class="form-check-input" defaultValue={inspection.id} name={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? "contactListemailsDisable" : "contactListemails"} defaultChecked={true} disabled={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? true : false} /><label class="form-check-label" for="check1" style={{textTransform:"none"}}>{inspection.name}</label></div> </div> :
         <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" defaultValue={inspection.id} class="form-check-input" name="contactListemails" /><label class="form-check-label" for="check1" style={{textTransform:"none"}}>{inspection.name}</label></div></div> )
      }
   }else{
      //  <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" class="form-check-input" defaultValue={inspection.id} name={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? "contactListemailsDisable" : "contactListemails"} defaultChecked={true} disabled={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? true : false} /><label class="form-check-label" for="check1">{inspection.name}</label></div> </div>
         // <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" defaultValue={inspection.id} class="form-check-input" name="contactListemails" /><label class="form-check-label" for="check1">{inspection.name}</label></div></div>
      }
   // } else {

   // }

}
// else if(inspectionNames.includes(inspection.name)){
//    if(inspectionNames.includes(inspection.name)){
//       return (
//     <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" class="form-check-input" defaultValue={inspection.id} name={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? "contactListemailsDisable" : "contactListemails"} defaultChecked={true} disabled={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? true : false} /><label class="form-check-label" for="check1">{inspection.name}</label></div> </div>
//          // <div class="form-check rem-shadow"> <div class="col-md-12">
//          //    {(inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft") ? <input type="checkbox" class="form-check-input" defaultValue={inspection.id} name={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? "contactListemailsDisable" : "contactListemails"} defaultChecked={true} disabled={true} /> : <input type="checkbox" class="form-check-input" defaultValue={inspection.id} name={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? "contactListemailsDisable" : "contactListemails"} />}

//          //    <label class="form-check-label" for="check1">{inspection.name}</label></div> </div>
//       )
//       }
//       else{
//          if (inspection.name === "Wet test certification") {
//    if (sessionStorage.getItem("vehicleTypeName") === "Trailer" && sessionStorage.getItem("tankerSubTypeName") === "Tanker") {
//          <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" defaultValue={inspection.id} class="form-check-input" name="contactListemails" /><label class="form-check-label" for="check1">{inspection.name}</label></div></div>
//       }}else{
//          <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" defaultValue={inspection.id} class="form-check-input" name="contactListemails" /><label class="form-check-label" for="check1">{inspection.name}</label></div></div>
//       }}
// }
else{

return (inspectionNames.includes(inspection.name) ?
<div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" class="form-check-input" defaultValue={inspection.id} name={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? "contactListemailsDisable" : "contactListemails"} defaultChecked={true} disabled={((inspectionStatus === "In Process") && (inspection.status === "approved") || (inspection.status === "Approved") || (inspection.status === "APPROVED") || (inspection.status === "approve") || (inspection.status === "Reject") || (inspection.status === "Rejected") || (inspection.status === "APPROVED PENDING") || (inspection.status === "approve pending") || (inspection.status === "APPROVE PENDING") || (inspection.status === "To Be Approved") || (inspection.status === "DRAFT") || (inspection.status === "draft") || (inspection.status === "Draft")) ? true : false} /><label class="form-check-label" for="check1" style={{textTransform:"none"}}>{inspection.name}</label></div> </div> :
<div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" defaultValue={inspection.id} class="form-check-input" name="contactListemails" /><label class="form-check-label" for="check1" style={{textTransform:"none"}}>{inspection.name}</label></div></div>)
                                 }
                              }
                                 )()}


                                    </>)
                                 }) : ""
                              }
                              {



                                 // inspectionNamearray ? inspectionNamearray.sort((a, b) => a.name.localeCompare(b.name)).map((data, index) => (



                                 //    (<>

                                 //       {(() => {

                                 //          if (data.name === "WET Test Certification") {
                                 //             if (sessionStorage.getItem("vehicleTypeName") === "Trailer" && sessionStorage.getItem("tankerSubTypeName") === "Tanker") {

                                 //                return (
                                 //                   <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" defaultValue={data.id} class="form-check-input" name="contactListemails" /><label class="form-check-label" for="check1">{data.name}</label></div></div>

                                 //                )
                                 //             } else {

                                 //             }

                                 //          } else {
                                 //             return (
                                 //                <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" defaultValue={data.id} class="form-check-input" name="contactListemails" /><label class="form-check-label" for="check1">{data.name}</label></div></div>

                                 //             )
                                 //          }

                                 //       })()}

                                 //       {/* <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" defaultValue={data.id} class="form-check-input" name="contactListemails" /><label class="form-check-label" for="check1">{data.name}</label></div></div> */}

                                 //    </>)




                                 // )) : ""

                              }
                              <span class="error" id="inspectionerror">Please choose at least one inspection</span><br />
                              <label for="addnotes" className="mt-2">Add Note </label>

                              <textarea id="noteVal" name="addnotes" rows="4" cols="50" maxLength="300" defaultValue={notes}>

                              </textarea>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div class="modal-footer px-3">
                     <button type="button" class="btn btn-secondary border" data-dismiss="modal" id="closeModal" onClick={cancel} >Cancel</button>
                     <button type="button" class="btn btn-primary" onClick={updateTaskOrder} >Submit</button>
                  </div>
               </div>

            </div>
         </div>
         <div class="modal fade" id="myModal">
            <div class="modal-dialog">
               <div class="modal-content" style={{ maxHeight: "550px" }}>


                  <div class="modal-header">
                     <h4 class="modal-title">Add TO</h4>
                     <button type="button" class="close" data-bs-dismiss="modal" id="CloseModel" aria-label="Close"><span aria-hidden="true">×</span></button>
                  </div>


                  <div class="modal-body scroll-auto">
                     <div class="row mb-4">
                        <div class="col-12">
                           <div class="search position-relative w-100">
                              <div class="search_input position-relative">
                                 <input type="text" id="searchText" value={search} placeholder="Search with customer name" className="form-control searchValues" onChange={e => onInputChange(e.target.value)} />
                                 {/* <a href="#" class="search-icon">
                                                                                    <img src="/images/icons/search.svg" alt=""/>
                                                                                </a> */}
                                 <button class="btn search-btn-pos-abs" type="submit">
                                    {/* <svg viewBox="0 0 24 24"><path d="M23.36,22,18,16.55A9.78,9.78,0,1,0,16.55,18L22,23.36a1,1,0,0,0,1.41,0A1,1,0,0,0,23.36,22ZM10.41,18.16a7.75,7.75,0,1,1,7.75-7.75A7.76,7.76,0,0,1,10.41,18.16Z"></path></svg> */}
                                 </button>
                              </div>

                              <a href="#" class="search-icon"> <img src="/images/icons/search.svg" alt="" /></a>
                              {/* <input type="search" id="gsearch" name="gsearch" placeholder="Search driver" class="pl-5 w-100" />
                                                  <a href="#" class="search-icon"> <img src="images/icons/search.svg" alt="" /></a> */}
                           </div>
                        </div>
                        <div class="col-12 mt-2 px-3" id="customerNames">
                           {
                              customerList ? customerList.map((data, index) => (
                                 <div class="form-check input-align-right align-items-center d-flex w-100  mt-3 mb-3" onClick={(event) => customerIds(event, index, data.customerName, data.customerId)} >
                                    <input class="form-check-input mt-0 mx-2" type="hidden" name="customerId" value={data.customerId} id="flexRadioDefault1" />

                                    <div class="d-flex align-items-center" id={"selectedCustomer" + index}>
                                       <div class="add-owner-logo">
                                          <img src="/images/transport-logo.jpg" alt="" />
                                       </div>



                                       <label class="form-check-label " for="flexRadioDefault1">  <b>{data.customerName}</b> </label>


                                    </div>
                                 </div>)) : "no record"
                           }


                        </div>
                     </div>

                     <div class="row mb-2" id="vehicleData">
                        <div class="col-12">
                           <div class="search position-relative w-100">
                              {/* <Search
                                                          placeholderName="VIN Number"
                                                          onSearch={value => {
                                                            searchVehicleList(value);
                                                          }}

                                                /> */}
                              <div class="search_input position-relative">
                                 <input type="text" id="searchText" value={Vehiclesearch} placeholder="Search with VIN or Unit number" className="form-control searchValues" onChange={e => onInputChangeForVehicle(e.target.value)} />
                                 {/* <a href="#" class="search-icon">
                                                                                    <img src="/images/icons/search.svg" alt=""/>
                                                                                </a> */}
                                 <button class="btn search-btn-pos-abs" type="submit">
                                    {/* <svg viewBox="0 0 24 24"><path d="M23.36,22,18,16.55A9.78,9.78,0,1,0,16.55,18L22,23.36a1,1,0,0,0,1.41,0A1,1,0,0,0,23.36,22ZM10.41,18.16a7.75,7.75,0,1,1,7.75-7.75A7.76,7.76,0,0,1,10.41,18.16Z"></path></svg> */}
                                 </button>
                              </div>
                              <a href="#" class="search-icon"> <img src="/images/icons/search.svg" alt="" /></a>
                              {/* <input type="search" id="gsearch" name="gsearch" placeholder="Search driver" class="pl-5 w-100" />
                                                  <a href="#" class="search-icon"> <img src="images/icons/search.svg" alt="" /></a> */}
                           </div>
                        </div>
                        <div class="col-12 mt-2 px-3" id="vehicleList" >
                           {
                              vehicleList ? vehicleList.map((data, index) => (
                                 <div class="form-check input-align-right align-items-center d-flex w-100  mt-3 mb-3" onClick={(event) => handleChange_vhicle(event, index, data.vinNumber, data.id, data.vehicleTypeName, data.trailerSubTypeName)}>
                                    <input class="form-check-input" type="hidden" name="flexRadioDefault" value={data.id} id="flexVehicleRadioDefault1" />
                                    <div class="d-flex align-items-center">
                                       <div class="add-driver-logo">
                                          <img src="/images/driver.png" alt="" />
                                       </div>
                                       <label class="form-check-label" for="flexVehicleRadioDefault1"><b>{data.vinNumber}</b><i class="input-helper"></i></label>
                                    </div>
                                 </div>
                              )) : "no record"
                           }



                        </div>
                     </div>
                     <div className="row" id="taskOrderForm">
                        <div class="col-md-12">
                           <div class="form-group mb-3">
                              <label for="wqes" class="w-100">Task Order Name <span class="star">*</span></label>
                              <input type="text" class="form-control" id="addtaskorderName" placeholder="Task order name" />
                              <span class="error" id="taskOrderNameErrorAdd" style={{ marginTop: "20px important" }}>Task order name is required</span>
                           </div>


                           <div class="form-group mb-3">

                                      <img src="images/icons/workorder-icon.svg" alt=""/>
                                      {/* <span class="mr-2 ml-2">Work order Number : </span> */}
                                      <label for="wqes" class="w-100">Work order Number <span class="star">*</span></label>
                                      <input type="input" class="form-control" placeholder="Enter W/O" id="workorder" />
                                      <span class="error" id="error-message-workOrderNumber">Work order number is required</span>
                           </div>
                           <div class="form-group mb-3">
                              <label for="wqes" class="w-100">Assign Date <span class="star">*</span></label>
                              {/* <input type="text" class="form-control" id="qwes"  defaultValue={orderDate}/> */}
                              <DatePicker id="originalDateAdd" minDate={moment(originalDate).toDate()} selected={originalDate} onChange={(date) => setOriginalDate(date)} name="originalDate" class="form-control" placeholderText="MM/DD/YYYY" />
                              {/* <DatePicker id="addassignDate" minDate={moment(originalDate).toDate()}  onChange={(date) => setOriginalDate(date)} name="originalDate" class="form-control" id="originalDate" placeholderText="MM/DD/YYYY" /> */}
                              <span class="error" id="assignDateErrorAdd" >Assign date is required</span>
                           </div>
                           <div class="form-group">
                              <label for="wqes" class="w-100">Inspection List <span class="star">*</span></label>
                              <div class="col-md-12" style={{ marginTop: "6px" }}><input type="checkbox" class="form-check-input" name="contactSelectAll" onClick={(e) => SelectAllContactList(e, "")} />
                                 <label style={{ marginLeft: "26px", fontWeight: "bold", marginBottom: "0px" }}   >Select All</label></div>
                              {

                                 inspectionTypes ? inspectionTypes.sort((a, b) => a.name.localeCompare(b.name)).map((inspection, index) => {

                                    return (<>

                                       {/* {
                                          <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" class="form-check-input" name="contactListemails" defaultValue={inspection.id} /><label class="form-check-label" for="check1" style={{ textTransform: "none" }}>{inspection.name}</label></div></div>
                                       } */}

                                       {(() =>
                                       {

                                          if (inspection.name === "WET Test Certification")
                                          {
                                             if (sessionStorage.getItem("vehicleTypeName") === "Trailer" && sessionStorage.getItem("tankerSubTypeName") === "Tanker") {

                                                return (
                                                   <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" class="form-check-input" name="contactListemails" defaultValue={inspection.id} /><label class="form-check-label" for="check1" style={{ textTransform: "none" }}>{inspection.name}</label></div></div>

                                                )
                                             } else {

                                             }

                                          } else if (inspection.name === "Tractor PM/Inspection" || inspection.name ==  "Tractor Preventive Maintenance/Inspection")
                                          {
                                             if (sessionStorage.getItem("vehicleTypeName") === "Tractor") {

                                                return (
                                                   <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" class="form-check-input" name="contactListemails" defaultValue={inspection.id} /><label class="form-check-label" for="check1" style={{ textTransform: "none" }}>{inspection.name}</label></div></div>

                                                )
                                             } else {

                                             }

                                          }
                                          else if (inspection.name === "Driver Vehicle Inspection")
                                          {
                                             if (sessionStorage.getItem("vehicleTypeName") === "Tractor") {

                                                return (
                                                   <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" class="form-check-input" name="contactListemails" defaultValue={inspection.id} /><label class="form-check-label" for="check1" style={{ textTransform: "none" }}>{inspection.name}</label></div></div>

                                                )
                                             } else {

                                             }

                                          } else {
                                             return (
                                                <div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" class="form-check-input" name="contactListemails" defaultValue={inspection.id} /><label class="form-check-label" for="check1" style={{ textTransform: "none" }}>{inspection.name}</label></div></div>

                                             )
                                          }
                                          {/*<div class="form-check rem-shadow"> <div class="col-md-12"><input type="checkbox" class="form-check-input" name="contactListemails" defaultValue={'13'} /><label class="form-check-label" for="check1" style={{ textTransform: "none" }}>{'Tractor PM Test'}</label></div></div>*/}

                                       })()}

                                    </>)
                                 }) : ""
                              }
                              <span class="error ml-2" id="addinspectionerror">Please choose at least one inspection</span>

                              <div className="clear mt-2">
                                 <label for="addnotes" className="mt-3">Add Note </label>
                                 <textarea id="addnotevalues" className="form-control" name="addnotes" rows="4" cols="50" maxLength="300" ></textarea>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="modal-footer">
                     <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="closeModalforadd">Close</button>
                     <a class="btn btn-primary" onClick={() => addTO(customerId, vehicleId)}>Submit</a>
                     {/* <button type="button" class="btn btn-primary">Save changes</button> */}
                  </div>
               </div>


               {/* <div class="modal-footer">
            <button type="button" class="btn btn-secondary border" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Submit</button>
            </div> */}

            </div>
         </div>

         <div id="myModalCustomer" class="modal fade" role="dialog">
            <div class="modal-dialog">


               <div class="modal-content">
                  <div class="modal-header">
                     <h5 class="modal-title" id="exampleModalLabel">Send to Customer</h5>
                     <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                     </button>
                  </div>
                  <div class="modal-body sc-mod-pop">
                     <div class="row">
                        <div class="col-md-12">
                           {/* <p id="emailErrorTaskOrder" class="error">Please enter one or more emails to send the documents to.</p> */}
                           <input type="checkbox" class="form-check-input" name="contactSelectAllfromsendc" onClick={(e) => SelectAllContactListFromSC(e, setChecked)} />
                           <label style={{ marginLeft: "26px", fontWeight: "bold", marginBottom: "11px" }}>Select All</label></div>
                        {

                           CustomerContactList.length > 0 ? CustomerContactList.map((data, index) => {
                              return (<>
                                 <div class="col-md-12">
                                    <div class="form-check">
                                       <input type="checkbox" class="form-check-input" name="contactListemailIds" value={`${data.email}`} onClick={(e) => CustomercontactId(e, setChecked, checked)} />
                                       <span style={{ marginLeft: "20px" }}>{data.firstName ? data.firstName.charAt(0).toUpperCase() + data.firstName.slice(1) : ""}</span>
                                    </div>

                                 </div>

                              </>)
                           }) :
                              <div class="no-data"><div class="m-auto"></div><span class="mt-2">No Data Available to Display</span>
                              </div>}

                              <lable style={{paddingLeft:"20px", display:"flex", paddingTop:"20px"}}>Please enter one or more emails to send the documents to.</lable>   
                        <AddRemoveInputField setInputList={setInputEmailList} inputList={emailforsendtoct} />
                       
                     </div>
                     {/* <div class="row">
                           <div class="col-md-12">
                              <select class="form-control custome-select" id="exampleFormControlSelect1">
                                 <option>One</option>
                                 <option>Two</option>
                                 <option>Three</option>
                              </select>
                           </div>
                           </div> */}
                  </div>
                  <div class="modal-footer">
                     <button type="button" class="btn btn-primary" data-dismiss="modal" onClick={() => SendtocustomerfromTaskOrder(sendtocustomerId, checked, taskOrderSelectedID, emailforsendtoct)} >Submit</button>
                  </div>
               </div>

            </div>
         </div>



      </>
   )
};

TaskOrder.propTypes = {};

TaskOrder.defaultProps = {};

export default TaskOrder;
